// Superbeings — scroll spine progress
document.addEventListener('DOMContentLoaded', function () {
  var spine = document.getElementById('spine');
  if (!spine) return;

  function updateSpine() {
    var h = document.documentElement;
    var scrollable = h.scrollHeight - h.clientHeight;
    var pct = scrollable > 0 ? (h.scrollTop / scrollable) * 100 : 0;
    spine.style.setProperty('--spine-progress', pct + '%');
  }

  window.addEventListener('scroll', updateSpine, { passive: true });
  updateSpine();
});
